import { render, staticRenderFns } from "./product_form.vue?vue&type=template&id=0b460092&scoped=true&"
import script from "./product_form.vue?vue&type=script&lang=js&"
export * from "./product_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b460092",
  null
  
)

export default component.exports